export default __webpack_public_path__ + "static/media/gangrenousstench.0c0dd663.png";